import IExtension from "./IExtension";
import { Naja } from "naja";
import { Dropdown } from "bootstrap";

export default class MainNavDropdownExtension implements IExtension {

    private backdrop: HTMLElement | null = null;

    public initialize(naja: Naja): void {
        naja.addEventListener('init', () => this.init());
    }

    private init(): void {
        // Sub-nav flyout dropdowns: use Popper fixed strategy to escape
        // the main-nav's overflow:hidden on desktop
        document.querySelectorAll('.main-nav .sub-nav-trigger[data-bs-toggle="dropdown"]').forEach((el) => {
            const trigger = el as HTMLElement;
            const existing = Dropdown.getInstance(trigger);
            if (existing) {
                existing.dispose();
            }
            new Dropdown(trigger, {
                popperConfig(defaultConfig: any) {
                    return {
                        ...defaultConfig,
                        strategy: 'fixed',
                        modifiers: [
                            ...(defaultConfig.modifiers ?? []),
                            {
                                name: 'offset',
                                options: {
                                    offset: ({ placement }: { placement: string }) =>
                                        placement === 'right-end' ? [5, 12] : [-5, 12],
                                },
                            },
                        ],
                    };
                },
            });

            // Dim and freeze the underlying page while a sub-nav flyout is open so the
            // submenu stands out and the background can't be scrolled (ECHO-2598 review).
            trigger.addEventListener('shown.bs.dropdown', () => this.lockBackground());
            trigger.addEventListener('hidden.bs.dropdown', () => {
                // Defer so switching directly between two flyouts doesn't flicker the backdrop off/on
                window.setTimeout(() => {
                    if (!document.querySelector('.main-nav .sub-nav-trigger[aria-expanded="true"]')) {
                        this.unlockBackground();
                    }
                }, 0);
            });
        });
    }

    private lockBackground(): void {
        // The whole page scrolls on <body>, so reserve the window scrollbar width to
        // avoid a horizontal content jump when scrolling is frozen.
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
            const currentPadding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
            document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
        }

        document.body.classList.add('sub-nav-flyout-open');

        if (!this.backdrop) {
            this.backdrop = document.createElement('div');
            this.backdrop.className = 'sub-nav-backdrop';
            document.body.appendChild(this.backdrop);
        }
        // Force reflow so the opacity transition runs on the freshly added element
        void this.backdrop.offsetHeight;
        this.backdrop.classList.add('show');
    }

    private unlockBackground(): void {
        document.body.classList.remove('sub-nav-flyout-open');
        document.body.style.paddingRight = '';
        this.backdrop?.classList.remove('show');
    }
}
